import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DCSummaryBlock slots="heading, buttons" theme="lightest" buttonPositionRight btnVariant="cta" isBtnVariant mdxType="DCSummaryBlock" />
    <h2 {...{
      "id": "why-document-generation-api"
    }}>{`Why Document Generation API?`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://video.tv.adobe.com/v/332120"
        }}>{`Product overview video`}</a></li>
    </ul>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className=" icon-xl-size padding-btm-zero-left-align horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/b09957a1df6c27cb3160b089ba5cf995/rapid-results.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "authoring-tools-for-improved-productivity"
    }}>{`Authoring Tools for Improved Productivity`}</h3>
    <p>{`Use our Adobe Document Generation Tagger Word add-in to quickly build custom branded Microsoft Word or PDF documents with data.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className=" icon-xl-size padding-btm-zero-left-align horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/34efbd2187e6084838acc16a6574b0a4/modify-pages.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "manipulate-and-merge-dynamic-data"
    }}>{`Manipulate and Merge Dynamic Data`}</h3>
    <p>{`Process text tags, calculations, repeating elements, and conditional statements at runtime.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className=" icon-xl-size padding-btm-zero-left-align horizontal-align-heading" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/b08e0940f1397958c4909789b13f00d4/high-fidelity.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "document-generation-with-signatures"
    }}>{`Document Generation with Signatures`}</h3>
    <p>{`Adobe Acrobat Sign integration allows you to generate documents with signatures including conditional logic for signature text tags.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      